/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Pit3_DInputs */

const en_sorter_pit3_d = /** @type {(inputs: Sorter_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorting removes key order noise from a diff, which is its most common use. It does nothing about array order noise, because arrays are deliberately left alone. If two documents contain the same list in a different sequence, a diff will still report every position as changed.`)
};

const ko_sorter_pit3_d = /** @type {(inputs: Sorter_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬은 diff에서 키 순서로 인한 잡음을 없애며, 이것이 가장 흔한 용도입니다. 배열 순서로 인한 잡음에는 아무 효과가 없습니다. 배열은 의도적으로 손대지 않기 때문입니다. 두 문서가 같은 목록을 다른 순서로 담고 있으면 diff는 여전히 모든 위치를 변경으로 보고합니다.`)
};

const ja_sorter_pit3_d = /** @type {(inputs: Sorter_Pit3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並べ替えは差分からキー順序によるノイズを取り除き、これが最も一般的な用途です。配列順序によるノイズには何の効果もありません。配列は意図的に手を付けないからです。2 つの文書が同じリストを異なる順序で持っていれば、差分は依然としてすべての位置を変更として報告します。`)
};

/**
* | output |
* | --- |
* | "Sorting removes key order noise from a diff, which is its most common use. It does nothing about array order noise, because arrays are deliberately left alon..." |
*
* @param {Sorter_Pit3_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_pit3_d = /** @type {((inputs?: Sorter_Pit3_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Pit3_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_pit3_d(inputs)
	if (locale === "ko") return ko_sorter_pit3_d(inputs)
	return ja_sorter_pit3_d(inputs)
});